import useActivityFilterStore, {
  TActivityFilterItem,
} from '../store/storeActivityFilter'

const useFilterItem = () => {
  const selectedFilter = useActivityFilterStore((state) => state.selectedFilter)

  const filterItemIsSelected = ({
    name,
    filterItemId,
  }: {
    name: string
    filterItemId: string
  }) => {
    const targetState: TActivityFilterItem[] = selectedFilter[name]

    return targetState?.some((item) => item.id === filterItemId)
  }

  return {
    filterItemIsSelected,
  }
}

export default useFilterItem
